export default function OpportunityWorkflowsIcon() {
  return (
    <svg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.756505 7.89708L0 7.14058L4.91916 2.18552L7.79083 5.05718L11.8209 1.07687H9.69188V0H13.6404V3.94854H12.5635V1.83356L7.79083 6.60627L4.91916 3.7346L0.756505 7.89708Z'
        fill='currentColor'
      />
    </svg>
  );
}
